
















import Vue from 'vue';
import LiquorTree from 'liquor-tree';
import { ToolsModel } from '@/types';
import { ToolsService } from '@/services/ToolsService';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { TreeViewHeader } from '@/components/shared';
import { TreeViewHelpers } from '@/mixins/treeView';
Vue.use(LiquorTree);

export default Vue.extend({
  name: 'ToolsTreeView',
  mixins: [TreeViewHelpers],
  props: {
    loading: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      permissionData: {} as ToolsModel,
      options: {
        checkbox: false,
        parentSelect: true
      }
    };
  },
  methods: {
    async getPermissions() {
      this._isLoading = true;
      this.permissionData = await ToolsService.getToolsAsync();
      this._isLoading = false;
    },
    navigate(node: any) {
      if (node.data.componentName && node.data.componentName.localeCompare(this.$router.currentRoute.name)) {
        this.$router.push({ name: node.data.componentName });
      } else {
        node.states.expanded = !node.states.expanded;
      }
    },
    getNode(this: any, tree: any) {
      const node = tree.find({
        data: { path: this.$route.meta.treePath }
      });
      if (!node) {
        return;
      }
      this.selectNode(node);
    }
  },
  watch: {
    '$route.meta.treePath'(this: any, treePath) {
      if (!treePath) {
        const selectedNode = this.$refs.tree.find({
          state: { selected: true }
        });
        this.unselectNode(selectedNode);
      }
    }
  },
  computed: {
    treeData(): object {
      return [
        {
          text: 'Automotive',
          data: { icon: 'car' },
          state: {
            visible: this.permissionData.canAccessDealCopyTool,
            selectable: false
          },
          children: [
            {
              text: 'Deal Document Copy',
              data: {
                icon: 'file'
              },
              state: {
                visible: this.permissionData.canAccessDealCopyTool,
                selectable: false
              },
              children: [
                {
                  text: 'Deal Copy Request',
                  data: {
                    icon: 'copy',
                    componentName: 'dealCopyRequest',
                    path: 'dealCopyRequest'
                  },
                  state: {
                    visible: this.permissionData.canAccessDealCopyTool
                  }
                },
                {
                  text: 'Request History',
                  data: {
                    icon: 'clock-rotate-left',
                    componentName: 'dealCopyHistory',
                    path: 'dealCopyHistory'
                  },
                  state: {
                    visible: this.permissionData.canAccessDealCopyTool
                  }
                }
              ]
            }
          ]
        },
        {
          text: 'HR',
          data: { icon: 'users' },
          state: {
            visible: this.permissionData.canAccessHr,
            selectable: false
          },
          children: [
            {
              text: 'Process Leaver',
              data: {
                icon: 'user-cog',
                componentName: 'processLeaver',
                path: 'processLeaver'
              },
              state: {
                visible: this.permissionData.canAccessLeaversTool
              }
            },
            {
              text: 'Process Leaver History',
              data: {
                icon: 'history',
                componentName: 'processLeaverHistory',
                path: 'processLeaverHistory'
              },
              state: {
                visible: this.permissionData.canAccessLeaversTool
              }
            }
          ]
        },
        {
          text: 'System',
          data: { icon: 'cogs' },
          state: {
            visible: this.permissionData.canAccessSystemTool,
            selectable: false
          },
          children: [
            {
              text: 'Remove Locks',
              data: {
                icon: 'unlock-alt',
                componentName: 'lockMaintenance',
                path: 'lockMaintenance'
              },
              state: {
                visible: this.permissionData.canAccessRemoveLocksTool
              }
            },
            {
              text: 'Clear Cache',
              data: {
                icon: 'wrench',
                componentName: 'clearCacheSettings',
                path: 'clearCacheSettings'
              },
              state: {
                visible: this.permissionData.canAccessCacheSettings
              }
            }
          ]
        },
        {
          text: 'Document Retention',
          data: {
            icon: 'recycle',
            componentName: 'documentRetention',
            path: 'documentRetention'
          },
          state: {
            visible: this.permissionData.canAccessDocumentRetention
          }
        }
      ];
    },
    _isLoading: {
      get(this: any) {
        return this.loading;
      },
      set(this: any, value: boolean) {
        this.$emit('update:loading', value);
      }
    }
  },
  mounted() {
    this.getPermissions();
  },
  components: {
    LoadingSpinner,
    TreeViewHeader
  }
});
